import React from 'react';
import { updateUserRole } from '../../../../services/authentication/signup';
// import { toast } from 'react-toastify';
import { clearTemporalSession } from '../../../../utils/tempSession';
import useIonicToast from '../../../../hooks/useIonicToast';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { RoleChangeDialogSchema } from '../../../../schemas/signInSchemas';
import z from 'zod';
import { useDialog } from '../../../../context/Dialog';
import { FirstDialogue } from './FirstDialogueStep';
import { SecondDialogue } from './SecondDialogStep';
import { useHistory } from 'react-router';

type Props = {
  email: string;
  password: string;
};

// MAIN ROLE CHANGE DIALOG
export default function RoleChangeDialogue({ email, password }: Props) {
  const { setBusy, closeDialog } = useDialog();
  const { presentIonToast } = useIonicToast();
  const [currentStep, setCurrentStep] = React.useState(0);
  const handleStepChange = (step: number) => setCurrentStep(step);
  const initialState: z.infer<typeof RoleChangeDialogSchema> = {
    email: email || '',
    password: password || '',
  };
  const history = useHistory();
  const formMethods = useForm({
    resolver: zodResolver(RoleChangeDialogSchema),
    defaultValues: { ...initialState },
  });
  const handleCancel = () => {
    handleStepChange(0);
    formMethods.reset({ ...initialState });
    clearTemporalSession();
    closeDialog();
  };

  const handleSubmission = formMethods.handleSubmit(async () => {
    if (!email) return;
    try {
      setBusy(true);
      if (password) await updateUserRole({ email, password });
      // else await updateUserRole({ email, token });
      presentIonToast("Congratulations!, You're now a store owner.");
      history.replace('/dashboard');
    } catch (error: any) {
      let msg = error.massage;

      // if (error.code === 400) msg = 'Invalid password';
      if (error.status === 401 && !password)
        msg = 'Token is invalid of has expired';
      else if (error.status === 201 || error.status === 409) {
        msg = 'Account created, try signing in now';
        handleCancel();
      }
      presentIonToast(msg, 'error');
    } finally {
      setBusy(false);
    }
  });

  const steps = [
    <FirstDialogue onContinue={() => handleStepChange(1)} />,
    <SecondDialogue onCancel={handleCancel} />,
  ];

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmission} className="dialog-content sm:w-96">
        {steps[currentStep]}
      </form>
    </FormProvider>
  );
}
